import React from 'react';
import { useViewport } from '../../hooks/useViewport';
import { OneColumnLayout, TwoColumnLayout } from '../../components/layouts';
import { Categories } from './Categories/Categories';
import { SideContent } from './Categories/SideContent';
import { MobileCategories } from './MobileCategories/MobileCategories';

export function CategoriesWrapper() {
  const { isMobile } = useViewport();

  if (isMobile) {
    return <OneColumnLayout content={<MobileCategories />} />;
  }

  return (
    <TwoColumnLayout
      mainContent={<Categories />}
      sideContent={<SideContent />}
      mainContentSpan={6}
      sideCellStyle={{ maxWidth: '550px' }}
    />
  );
}
